/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all, delay } from "redux-saga/effects"

import {
 
  LOAD_RECORDS,
  CREATE_RECORD,
  UPDATE_RECORD,
  DELETE_RECORD,
  LOAD_RECORDS_META_DATA,
 
} from "./constants"

import {
  loadRecords as loadRecordsAction,
  loadRecordsSuccess,
  loadRecordsError,
  createRecordSuccess,
  createRecordError,
  updateRecordSuccess,
  updateRecordError,
  deleteRecordSuccess,
  deleteRecordError,
 
 
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
 
} from "./actions"

import {
  loadRecords,
 
  createRecord,
  updateRecord,
  deleteRecord,
  loadRecordsMetaData,
 
} from "./remotes"



//import { selectSession } from "../session/selectors"
//import { roleIds } from "../../helpers/tools"
function* loadRecordsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORDS),
    })

    const { explicitLoad } = load

    if (explicitLoad) {
      try {
        const result = yield call(loadRecords)

        console.log(result, "result")

        if (result) {
          yield put(loadRecordsSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadRecordsSuccess([]))
          yield put(loadRecordsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadRecordsSuccess([]))
        yield put(
          loadRecordsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}



function* createRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_RECORD),
    })
    const { record} = create || {}
    if (create) {
     // yield call(setSubmitting, true)
      try {
        yield call(createRecord, record)

        yield delay(1000)
        yield put(createRecordSuccess(record))
        yield put(loadRecordsAction(true))
       
      } catch (error) {
        yield put(
          createRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } 
    }
  }
}

function* editRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_RECORD),
    })
    const { record } = edit || {}
    if (edit) {
      //yield call(setSubmitting, true)

      try {
        yield call(updateRecord, record)
        yield delay(1000)
        yield put(updateRecordSuccess(record, "Record Updated Successfully"))
       // yield call(redirect)
      } catch (error) {
        yield put(
          updateRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      }
    }
  }
}

function* deleteRecordSaga() {
 
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_RECORD),
    })
    const {deleteData} = create || {}
    if (create) {
     // yield call(setSubmitting, true)
      try {
        yield call(deleteRecord, deleteData)

        yield delay(1000)
        yield put(deleteRecordSuccess(deleteData))
        yield put((true))
       
      } catch (error) {
        yield put(
          deleteRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } 
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
     
      const freelancer = yield call(loadRecordsMetaData,"freelancer","post")
      const service = yield call(loadRecordsMetaData,"service","post")
      console.log(freelancer)
      let recordsMetaData = {
        freelancerOptions: (freelancer &&
          freelancer.data &&
          freelancer.data.length > 0 &&
          freelancer.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                { label: c.freelancerName.concat(" - ", c.phoneNumber1), value: c._id}
                 
              )
            )) ||
        [],
        serviceOptions:
        (service &&
          service.data &&
          service.data.length > 0 &&
          service.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                { label: c.serviceName, value: c._id,servicePrice:c.amount}
                 
              )
            )) ||
        [],
      servicePriceOptions: (service &&
        service.data &&
        service.data.length > 0 &&
        service.data
          .filter((_) => _.status === 1)
          .map((c) =>
            Object.assign(
              {},
              { label: c.amount, value: c._id}
               
            )
          )) ||
      [],
    
       
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}


export default function* recordsSaga() {
  yield all([
   
    loadRecordsSaga(),
    createRecordSaga(),
    editRecordSaga(),
    deleteRecordSaga(),
    loadRecordsMetaDataSaga(),
    
  ])
}
